export default "__VITE_ASSET__Bu5V0PR4__"